import { ref, computed, reactive, readonly } from 'vue'
import { defineStore } from 'pinia'
import moment from 'moment'

export interface iPermission {
  read_action: string[]
  write_action: string[]
  update_action: string[]
  approval_action: string[]
  delete_action: string[]
}

export const userPermissionStore = defineStore('userPermission', () => {
  const fetched = ref<boolean>(false)
  const permission = reactive<iPermission>({
    read_action: [],
    write_action: [],
    update_action: [],
    approval_action: [],
    delete_action: []
  } as iPermission)

  const getUserPermission = readonly(permission)
  const isFetched = readonly(fetched)

  function setUserProfile(permissionPbject: iPermission) {
    permission.read_action = permissionPbject.read_action
    permission.write_action = permissionPbject.write_action
    permission.update_action = permissionPbject.update_action
    permission.approval_action = permissionPbject.approval_action
    permission.delete_action = permissionPbject.delete_action
  }
  function setDefault() {
    permission.read_action = []
    permission.write_action = []
    permission.update_action = []
    permission.approval_action = []
    permission.delete_action = []
  }
  function setFetchFlag(state: boolean) {
    fetched.value = state
  }

  return { getUserPermission, isFetched, setUserProfile, setFetchFlag, setDefault }
})
